module.exports = __webpack_public_path__ + "static/img/12.26c4e89.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/pic/12.jpg
// module id = 18f+
// module chunks = 1